import { ICellRendererParams } from 'ag-grid-community'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import styled from 'styled-components'
import { ReportStatusIcon } from '../status-icon'
import { ReportStatusSelect } from '../inputs/ReportStatusSelect'
import { VersionReportStatus } from '../../../../../domain/entity/version-report/VersionReportVersionEntity'

interface ReportStatusCellRendererProps
  extends ICellRendererParams<ProgressReportTableContent> {
  editing: boolean
  updateTableContent: (
    content: ProgressReportTableContent,
    rowIndex: number
  ) => void
}

export const ReportStatusCellRenderer = ({
  editing,
  updateTableContent,
  ...params
}: ReportStatusCellRendererProps) => {
  const content = params.data!
  const rowIndex = params.node.rowIndex!
  if (!editing) {
    return (
      <StatusIcon>
        <ReportStatusIcon status={content.status} />
      </StatusIcon>
    )
  }
  return (
    <ReportStatusSelect
      status={content.status}
      onChange={(v: VersionReportStatus) =>
        updateTableContent({ ...content, status: v }, rowIndex)
      }
    />
  )
}

const StatusIcon = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
})
